import React from 'react';
import { Col, Row } from 'antd';

import LogosBackground from '../../assets/images/login-company-logos.png';


export default function LoginImageInfoContainer() {
  return (
    <div className="login-side-image-info-container">
      <Row align="middle">
        <Col className="login-side-image-info-container-title">
          10,000+ PROJECTS TRUSTED BY ONTRACCR
        </Col>
      </Row>
      <Row>
        <Col className="login-side-image-info-container-description">
          Every construction business is unique, and Ontraccr is the only platform designed for adaptability at every level.
        </Col>
      </Row>
      <img alt="Login Background" src={LogosBackground} className="login-side-image-info-container-background" />
    </div>
  );
};